import { render, staticRenderFns } from "./ScheduleResourcesManager.vue?vue&type=template&id=0da59261&scoped=true&"
import script from "./ScheduleResourcesManager.vue?vue&type=script&lang=js&"
export * from "./ScheduleResourcesManager.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleResourcesManager.vue?vue&type=style&index=0&id=0da59261&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da59261",
  null
  
)

export default component.exports